import React from "react";
import "./loader.css";

export const FullScreenLoader = ({ message = "Subiendo imágenes..." }) => {
  return (
    <div className="fullscreen-loader-overlay">
      <div className="fullscreen-loader-content">
        <div className="loader"></div>
        <p className="loader-message">{message}</p>
      </div>
    </div>
  );
}; 